import { FC } from "react";
import { useTranslation } from "react-i18next";
import { Box } from "@chakra-ui/react";
import { AddressElement } from "@stripe/react-stripe-js";
import { useCurrentUser } from "~/hooks/useCurrentUser";
import { CardContainer } from "./CardContainer";
import { CardTitle } from "./CardTitle";

export const BillingAddressCard: FC = () => {
  const { t } = useTranslation();
  const currentUser = useCurrentUser();

  return (
    <CardContainer gap={6}>
      <CardTitle>{t("planPayment.billingAddress.title")}</CardTitle>
      <Box w="full">
        <AddressElement
          options={{
            mode: "billing",
            defaultValues: {
              name: `${currentUser?.firstName} ${currentUser?.lastName}`,
            },
          }}
        />
      </Box>
    </CardContainer>
  );
};
